import { TableCell, TableBody, Table, TableRow } from '@mui/material';
import { WidgetPanel } from './WidgetPanel';
import { WidgetTitle } from './WidgetTitle';
import { Link } from 'react-router-dom';
import LoadingSpinner from '../components/LoadingSpinner';
import { gql } from '../__generated__';
import { useQuery } from '@apollo/client/react';
import { useState } from 'react';
import { numberFormatted } from '../Formatters';

const QUERY = gql(`
  query NewSubscriptionsSummary($monthOffset: Int!) {
    summary: getNewSubscriptionsSummary(monthOffset: $monthOffset) {
      newLicenses
      newUsers {
        subscription
        name
        userCount
      }
    }
  }
`);

export function NewSubscriptionsSummary() {
  const [monthOffset, setMonthOffset] = useState(0); // get statistics for current month by default

  const { data } = useQuery<any, any>(QUERY, { variables: { monthOffset: monthOffset } });

  const LinkToDetails = (props) => (
    <Link to={`/report?tab=6&offset=${props.offset}`} title={props.title}>
      {props.children}
    </Link>
  );

  return (
    <div>
      <WidgetPanel>
        <WidgetTitle
          title="Nye kunder og brukere i"
          offset={monthOffset}
          forwardLimit={1}
          stateSetter={(step) => {
            setMonthOffset(monthOffset + step);
          }}
        />

        {!data && <LoadingSpinner />}
        {data && (
          <Table padding="none">
            <TableBody>
              <TableRow>
                <TableCell>Nye kunder:</TableCell>
                <TableCell align="right">{data.summary.newLicenses}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    borderBottom: 'none',
                  }}
                  colSpan={2}>
                  &nbsp;
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={2}>Nye brukere:</TableCell>
              </TableRow>
              {data.summary.newUsers.map((n, i) => (
                <TableRow key={i}>
                  <TableCell>{n.name}:</TableCell>
                  <TableCell align="right">{numberFormatted(n.userCount)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
        <LinkToDetails offset={monthOffset}>Se mer</LinkToDetails>
      </WidgetPanel>
    </div>
  );
}
